<template>
  <QDialog v-model="showDialog" no-esc-dismiss persistent>
    <QCard style="padding: 25px 0; width: 400px; max-width: 80vw">
      <div class="row justify-center items-center q-pa-md" style="width: 100%">
        <div class="col-12" style="text-align: center">
          <img
            :src="popupImage ? popupImage : '/assets/images/document_check.png'"
            class="header-logo"
            style="max-width: 200px; max-height: 200px"
          />
        </div>
        <div class="col-12" style="text-align: center; padding-top: 10px">
          <h4 style="color: var(--primary-color)">Are you sure your details are correct?</h4>
        </div>
        <div class="col-md-8 col-sm-12" style="text-align: center"></div>
      </div>
      <div class="text-center">
        <QBtn color="primary" no-caps outline @click="onCancel()">Edit</QBtn>
        <QBtn color="primary" no-caps @click="onSubmit()" style="margin-left: 20px">Confirm</QBtn>
      </div>
    </QCard>
  </QDialog>
</template>

<script>
import { QBtn, QDialog, QCard } from 'quasar';
import { mapGetters } from 'vuex';

export default {
  name: 'IDScanConfirmDialog',
  components: { QBtn, QDialog, QCard },
  data: function () {
    return {
      showDialog: true
    };
  },
  computed: {
    ...mapGetters({ orgProfile: 'theme/getScoreboard' }),
    popupImage() {
      if (this.orgProfile?.popupImage1) {
        return this.orgProfile.popupImage1;
      } else {
        return null;
      }
    }
  },
  created() {},
  methods: {
    onCancel: function () {
      setTimeout(() => {
        this.$emit('closeIDScanConfirmDialog');
        this.showDialog = false;
      });
    },
    onSubmit: function () {
      setTimeout(() => {
        this.$emit('submitIDScanConfirmDialog');
        this.showDialog = false;
      });
    }
  }
};
</script>
